<template>
  <div class="navigation-routing">
    <div class="nav-buttons" role="navigation" aria-label="Quick navigation">


      <button class="app-back-btn" @click="goBack" aria-label="Go back"><img
          src="../assets/universalIcons/leftArrow.svg" alt="back" loading="lazy"></button>

      <!-- Profile button -->
      <!-- <button @click="goProfile" aria-label="Go to profile">Profile</button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "NavigationButtons",
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.goProfile();
      }
    },
    goProfile() {
      const groupId = this.$store.getters.hasuserdetails?.group_id;
      console.log("groupId:", groupId);

      if (!groupId) {
        this.$router.push("/login"); // if somehow not logged in
        return;
      }
      if (groupId == 1) {
        this.$router.push("/admin");
      } else if (groupId == 2) {
        this.$router.push("/doctor");
      } else if (groupId == 3) {
        this.$router.push("/vendor");
      } else if (groupId == 4) {
        this.$router.push("/customer");
      } else if (groupId == 5) {
        this.$router.push("/student");
      } else if (groupId == 5) {
        this.$router.push("/student");
      } else {
        this.$router.push("/"); // safe fallback
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app-back-btn {
  position: relative;
  /* important for movement */
  animation: moveLeftRight 2.5s ease-in-out infinite;
}

@keyframes moveLeftRight {
  0% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(15px);
  }

  100% {
    transform: translateX(0);
  }
}

.app-back-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 5px;
  background: linear-gradient(to right, #6b0123, #a71d42);
  border: none;
}

.app-back-btn img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

/* .navigation-routing {
  border: 1px solid #6b0123;
  padding: 4px;
  border-radius: 50%;
} */

.nav-buttons {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  gap: 10px;
  z-index: 9999;
  /* border: 1px solid #6b0123; */
  padding: 5px;
  border-radius: 6px;
}

/* Floating button style */
/* .nav-buttons button {
  border-radius: 6px;
  border: none;
  background: #6b0123;
  color: white;
  font-size: 16px;
  padding: 5px;
  font-size: clamp(11px, 2vw, 13px);
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: background 0.3s ease, transform 0.2s ease;
} */

/* Hover effect */
/* .nav-buttons button:hover {
  background: #6b0a23;
  transform: scale(1.1);
} */

/* Responsive: move slightly up for very small screens */
@media (max-width: 480px) {
  .nav-buttons {
    bottom: 15px;
    right: 15px;
  }
}


</style>
